// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-6e024e25]{display:flex;flex-direction:column;gap:1rem;align-items:center}.icon[data-v-6e024e25]{color:var(--color-text-secondary)!important}", ""]);
// Exports
module.exports = exports;
